<template>
  <div
    :class="[
      'default__container',
      { 'default__container--with-banner': isReportPreview }
    ]"
  >
    <FreeToolBanner v-if="isReportPreview" />
    <router-view></router-view>
  </div>
</template>

<script>
import { intercomMixin } from "@/helpers/mixins/intercom";
import { isFeatureFlagEnabled, FEATURE_FLAG } from "@/helpers/posthog";
import FreeToolBanner from "@/views/CompetitionComparison/components/FreeToolBanner.vue";

export default {
  name: "FreeToolLayout",
  mixins: [intercomMixin],
  components: {
    FreeToolBanner
  },
  computed: {
    isReportPreview() {
      return this.$route.name === "reviews-competition-comparison-free-tool-v2";
    },
    languages() {
      return this.$store.state.settings.languages;
    }
  },
  async created() {
    await this.setLanguage();
    if (
      isFeatureFlagEnabled(FEATURE_FLAG.CEN_235_COMPEITION_ANALYSIS_FREE_TOOL)
    ) {
      await this.setIntercom();
    } else {
      this.$router.push({ name: "dashboard" });
    }
  },
  methods: {
    checkLanguage(locale) {
      return this.languages.find(lang => lang.locale === locale);
    },
    async setLanguage() {
      const lang = this.checkLanguage(this.$route.params.lang)
        ? this.$route.params.lang
        : "en";
      this.$store.dispatch("settings/setLanguage", lang);
      await this.$router.replace({
        params: { lang },
        query: this.$route.query
      });
    }
  },
  watch: {
    "$store.state.settings.selectedLocale": {
      async handler(newVal, prevVal) {
        if (newVal !== prevVal) {
          await this.$router.replace({
            params: { lang: newVal },
            query: this.$route.query
          });
          this.$router.go(0);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.default__container {
  &--with-banner {
    padding-top: 46px;
  }
}
</style>
